import { reportApi } from '../api/reportApi';
import type {
    WordReportItem,
    ReportSummary,
    ReportFilterParams,
    UpdateReportStatusRequest,
} from '../types/report';
import {
    useBaseQuery,
    useNoDataMutation,
    useInvalidateQueries,
} from './useBaseQuery';
import { PaginationData } from '../models/paginationData';

export const reportKeys = {
    all: ['report'] as const,
    lists: () => [...reportKeys.all, 'list'] as const,
    list: (params: ReportFilterParams) => [...reportKeys.lists(), params] as const,
    summary: () => [...reportKeys.all, 'summary'] as const,
};

export const useReports = (params: ReportFilterParams) => {
    return useBaseQuery<PaginationData<WordReportItem>>(
        reportKeys.list(params),
        () => reportApi.getReports(params),
        { staleTime: 10_000 },
    );
};

export const useReportSummary = () => {
    return useBaseQuery<ReportSummary>(
        reportKeys.summary(),
        () => reportApi.getSummary(),
        { staleTime: 10_000 },
    );
};

export const useUpdateReportStatus = () => {
    const { invalidateMultiple } = useInvalidateQueries();

    return useNoDataMutation<{ reportId: number; data: UpdateReportStatusRequest }>(
        ({ reportId, data }) => reportApi.updateStatus(reportId, data),
        {
            onSuccess: () => {
                invalidateMultiple([
                    reportKeys.lists(),
                    reportKeys.summary(),
                ]);
            },
        },
    );
};
